import EcAuthContext, { EcAuthProvider } from "./services/auth";
import ECAuthInterceptor from "./interceptor";
import ECAxiosAPI, { AxiosAPI } from "./services/API";
import { EcLayout } from "./components/layout";

import "./styles.css";
import AuthInterceptor from "./interceptor/AxiosAPI";

const packageJSON = require("../package.json");
console.log("ec-auth v", packageJSON.version);

const interceptor = new ECAuthInterceptor();
interceptor.initRequestInterceptor();
interceptor.initResponseInterCeptor();

const interceptor2 = new AuthInterceptor();
interceptor2.initRequestInterceptor();
interceptor2.initResponseInterCeptor();

export {
  EcAuthContext,
  EcAuthProvider,
  EcLayout,
  ECAuthInterceptor,
  ECAxiosAPI,
  AxiosAPI
};
